import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import Swal from "sweetalert2";
import usePDFDownload from "../../../hooks/usePDFDownload";
import baseUrl from "../../../utilities/baseUrl";
import LoadingButton from "../../Loading/LoadingButton";
import styles from "./PrintLink.module.css";

const PrintLink = ({
  ids = [],
  className = "",
  children,
  byNumberParcel = false,
  onFaild = undefined,
}) => {
  const token = localStorage.getItem("token");
  const { blobToFile } = usePDFDownload();

  const classes = [
    "btn",
    "btn-outline-primary",
    "text-center",
    styles.btn,
  ].join(" ");

  const { mutate, isPending } = useMutation({
    mutationKey: ["factor-pdf"],
    mutationFn: () =>
      axios
        .post(
          baseUrl + "/totalpost/v1/mainFactor",
          {
            ids,
            byNumberParcel: byNumberParcel ?? false,
          },
          {
            headers: {
              Authorization: "Bearer " + token,
            },
            responseType: "blob",
          }
        )
        .then(res => res.data),

    onSuccess: blobToFile,

    onError: async error => {
      let message = "";

      try {
        const object = JSON.parse(await error.response.data.text());
        message = object.message;
      } catch (error) {
        message = "در ارتباط با سرور با خطا مواجه شدیم";
      }

      Swal.fire({
        icon: "error",
        text: message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "red",
      }).then(() => {
        if (onFaild !== undefined) {
          onFaild();
        }
      });
    },
  });

  if (!token || ids.length === 0 || ids[0] === null || ids[0] === undefined) {
    return (
      <button className={className !== "" ? className : "buttonUi"}>
        {children}
      </button>
    );
  }

  if (isPending)
    return (
      <LoadingButton
        className={className !== "" ? className : classes}
        center
        title="در حال دریافت"
      />
    );

  return (
    <button
      className={className !== "" ? className : classes}
      onClick={mutate}
      title="پرینت فاکتور"
    >
      {children}
    </button>
  );
};

export default PrintLink;
